var render = function () {
  var _vm$matchup, _vm$matchup$compareFi, _vm$matchup2, _vm$matchup2$compareF;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    key: "".concat(_vm.packageProjectSlugById),
    staticClass: "page__compare"
  }, [_c('b-modal', {
    attrs: {
      "id": "modal-help",
      "title": "Pomoč",
      "size": "xl",
      "scrollable": "",
      "centered": "",
      "ok-only": "",
      "ok-title": "Zapri",
      "header-bg-variant": "primary",
      "header-text-variant": "white"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.intro_text)
    }
  }), _vm.project.intro_img ? _c('div', [_c('img', {
    staticClass: "img-fluid d-block mx-auto mt-4",
    attrs: {
      "src": "".concat(_vm.helperImgPath, "/").concat(_vm.project.intro_img),
      "alt": _vm.project.title
    }
  })]) : _vm._e()]), _c('h4', {
    staticClass: "title pt-4 pb-4 mb-md-4 text-center bg-primary text-white"
  }, [_vm._v(" " + _vm._s(_vm.project.matchup_title) + " "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-help",
      modifiers: {
        "modal-help": true
      }
    }],
    staticClass: "mr-5 float-right btn-soft-primary",
    attrs: {
      "size": "sm",
      "variant": "light"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "question-circle"
    }
  })], 1)], 1), _c('section', {
    staticClass: "d-flex align-items-center justify-content-center"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm.isSending && _vm.loading ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 text-center"
  }, [_c('b-spinner', {
    staticClass: "m-5",
    staticStyle: {
      "width": "5rem",
      "height": "5rem"
    },
    attrs: {
      "label": "Busy",
      "variant": "info"
    }
  })], 1)]) : _c('div', [_c('div', {
    staticClass: "compare position-relative"
  }, [_c('div', {
    ref: "pageGrid",
    staticClass: "page__compare__grid",
    class: {
      horizontal: _vm.horizontal
    },
    style: _vm.getGridColumnWidth(),
    on: {
      "load": _vm.handleScroll,
      "&scroll": function scroll($event) {
        return _vm.handleScroll($event);
      }
    }
  }, [_vm.project.compare ? _vm._l((_vm$matchup = _vm.matchup) === null || _vm$matchup === void 0 ? void 0 : (_vm$matchup$compareFi = _vm$matchup.compareFields) === null || _vm$matchup$compareFi === void 0 ? void 0 : _vm$matchup$compareFi.slice(1, (_vm$matchup2 = _vm.matchup) === null || _vm$matchup2 === void 0 ? void 0 : (_vm$matchup2$compareF = _vm$matchup2.compareFields) === null || _vm$matchup2$compareF === void 0 ? void 0 : _vm$matchup2$compareF.length), function (field, fieldIndex) {
    return _c('div', {
      key: "item-".concat(fieldIndex),
      staticClass: "card-compare"
    }, [_c('div', {
      staticClass: "d-flex flex-column justify-content-center align-items-center"
    }, [field !== null && field !== void 0 && field.card_index ? _c('b-badge', {
      staticClass: "card-compare__badge",
      attrs: {
        "pill": "",
        "variant": "dark"
      }
    }, [_vm._v(_vm._s(_vm.headerBadge(field === null || field === void 0 ? void 0 : field.card_index)))]) : _vm._e(), _c('CardCompareTitle', {
      attrs: {
        "attrib": {
          field: field,
          label: field === null || field === void 0 ? void 0 : field.label
        },
        "imgPath": _vm.imgPath
      }
    })], 1), _c('div', {
      staticClass: "card-compare__divider"
    }), _vm._l(_vm.matchup.compareItems, function (item, itemIndex) {
      return [_c('div', {
        key: "stat-".concat(itemIndex),
        staticClass: "d-flex flex-column align-items-center mt-0"
      }, [_c('CardCompareLabel', {
        attrs: {
          "attrib": item[field.key],
          "imgPath": _vm.imgPath
        }
      }), _c('CardCompare', {
        attrs: {
          "attrib": item[field.key],
          "imgPath": _vm.imgPath
        }
      })], 1), _c('div', {
        key: "separator-".concat(itemIndex),
        staticClass: "card-compare__divider"
      })];
    }), _c('div', {
      staticClass: "d-flex justify-content-center align-items-center"
    }, [_c('b-button', {
      staticClass: "d-flex px-4",
      attrs: {
        "variant": "primary"
      },
      on: {
        "click": function click($event) {
          _vm.chooseWinner(_vm.getMatchupCardById(field.id));
        }
      }
    }, [_c('font-awesome-icon', {
      staticClass: "text-white",
      attrs: {
        "icon": "thumbs-up"
      }
    })], 1)], 1)], 2);
  }) : _vm._l(_vm.matchup.cards, function (card) {
    return _c('div', {
      key: card.id
    }, [card.attr_json ? _c('CardData', {
      attrs: {
        "attribs": JSON.parse(card.attr_json),
        "imgPath": _vm.imgPath
      },
      on: {
        "vote": function vote($event) {
          return _vm.chooseWinner(card);
        }
      }
    }) : _vm._e()], 1);
  })], 2), _c('div', {
    staticClass: "page__compare__fade-out",
    style: "opacity: ".concat(_vm.fadeOutOpacity, ";")
  })])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }